// @ vendors
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// @ utilities
import { formatText, FormattedText } from 'core/i18n';

// @components
import CreditCardAnchorButton from 'components/CreditCardComponents/CreditCardInitialSection/commons/CreditCardAnchorButton';
import CreditCardFeatureInfo from 'components/CreditCardComponents/CreditCardInitialSection/CreditCardInitialInfoSection/CreditCardFeaturesInfo/CreditCardFeatureInfo';
import { LoginModal } from 'components/commons/loginForm/LoginModal';
import ConditionalToggling from 'utilities/toggling/ConditionalToggling/ConditionalToggling';

// @ utilities
import { recordCreditCardEvent, PAGE_INITIAL } from 'utilities/uTagging';
import { PROCESS_TYPE_ONBOARDING } from 'utilities/uTagConstants';
import { buildPartnerPrivateUrl } from 'utilities/buildURLs';

// @ constants
import { API_APPLICATION } from 'constants/index';
import { getCreditCardInfoFeatures } from 'constants/creditCard/initialStepSections';
import { PATH_CREDIT_CARD_ONBOARDING } from 'constants/uTagConstants/paths';
import { EVENT_CREDIT_CARD } from 'constants/uTagConstants/RAConstants';
import { BASIC } from 'constants/creditCard/partners';
const THEME1 = 'theme1';
const THEME2 = 'theme2';
const THEME3 = 'theme3';

// @ HOCS
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';
class CreditCardFeaturesInfo extends Component {
    state = {
        showLoginForm: false,
    };

    handleClickShowLogin = () => {
        const { showLoginForm } = this.state;

        this.setState({ showLoginForm: !showLoginForm });

        recordCreditCardEvent(
            PATH_CREDIT_CARD_ONBOARDING,
            PAGE_INITIAL,
            PROCESS_TYPE_ONBOARDING,
            EVENT_CREDIT_CARD,
            'haz click aqui accordion header'
        );
    };

    handleRedirectLoginSuccess = (response, defaultLoginSuccess) => {
        if (response.application === API_APPLICATION) {
            location.href = buildPartnerPrivateUrl(this.props.partner.get('id'));
        } else {
            defaultLoginSuccess();
        }
    };

    mapFeaturesWith = features => {
        const {
            userProfile: { productStandard },
        } = this.props;
        return features.map(featureProps => {
            if (this.props.partner.get('id') === BASIC && featureProps.index === 2) return;
            return (
                <CreditCardFeatureInfo key={featureProps.index} {...featureProps} productStandard={productStandard} />
            );
        });
    };

    getTheme(theme) {
        switch (theme) {
            case '2':
                return THEME2;
            case '3':
                return THEME3;
            case '1':
            default:
                return THEME1;
        }
    }

    render() {
        const features = this.mapFeaturesWith(getCreditCardInfoFeatures(this.props.partner));
        const tcDisplayLoginLink = this.props.flags.get('tcDisplayLoginLink');
        const theme = this.getTheme(this.props.partner.get('theme'));

        return (
            <div>
                {features}
                <div className="row tc-section-footer">
                    <div className="tc-section-footer-condition-links">
                        <span
                            className={`link ${theme}`}
                            onClick={() =>
                                recordCreditCardEvent(
                                    PATH_CREDIT_CARD_ONBOARDING,
                                    PAGE_INITIAL,
                                    PROCESS_TYPE_ONBOARDING,
                                    EVENT_CREDIT_CARD,
                                    'condiciones'
                                )
                            }
                        >
                            <FormattedText
                                value={`initialAddInfoSection-pdfConditionsLink_${this.props.partner.get('id')}`}
                            />
                        </span>
                        <span
                            className={`link ${theme}`}
                            onClick={() =>
                                recordCreditCardEvent(
                                    PATH_CREDIT_CARD_ONBOARDING,
                                    PAGE_INITIAL,
                                    PROCESS_TYPE_ONBOARDING,
                                    EVENT_CREDIT_CARD,
                                    'informacion precontractual'
                                )
                            }
                        >
                            <FormattedText
                                value={`initialAddInfoSection-pdfPrecontractInfo_${this.props.partner.get('id')}`}
                            />
                        </span>
                    </div>
                    <div className="tc-section-footer-button">
                        <CreditCardAnchorButton
                            text={formatText('initialInfoSection-getItButton')}
                            handleClick={() => {
                                recordCreditCardEvent(
                                    PATH_CREDIT_CARD_ONBOARDING,
                                    PAGE_INITIAL,
                                    PROCESS_TYPE_ONBOARDING,
                                    EVENT_CREDIT_CARD,
                                    'consiguela ahora accordion header'
                                );
                            }}
                        />
                        <ConditionalToggling condition={tcDisplayLoginLink}>
                            <div className="tc-section-footer-button-link-text">
                                <span className="tc-section-footer-button-link-label">
                                    {formatText(
                                        `initialInfoSection-clientcontentLinkPart2_${this.props.partner.get('id')}`
                                    )}
                                </span>
                                <a className="a-dark-blue-link" onClick={() => this.handleClickShowLogin()}>
                                    {formatText(`initialInfoSection-clientLinkPart2_${this.props.partner.get('id')}`)}
                                </a>
                            </div>
                        </ConditionalToggling>
                    </div>
                    <p>
                        <FormattedText value={`initialInfoSection-clientLink_${this.props.partner.get('id')}`} />
                    </p>
                    {this.props.partner.get('free') && (
                        <p className="legal-condition">
                            <FormattedText
                                value={`initialInfoSection-descriptionFreeLegalText_${this.props.partner.get('id')}`}
                            />
                        </p>
                    )}
                </div>
                <LoginModal
                    show={this.state.showLoginForm}
                    onClose={this.handleClickShowLogin}
                    onLoginSuccess={this.handleRedirectLoginSuccess}
                />
            </div>
        );
    }
}

CreditCardFeaturesInfo.propTypes = {
    title: PropTypes.string,
    titleModifier: PropTypes.string,
    subTitleModifier: PropTypes.string,
    paragraphModifier: PropTypes.string,
    container: PropTypes.string,
    paragraph: PropTypes.string,
    dash: PropTypes.string,
};

export default connect(state => ({
    userProfile: state.userProfile,
    products: state.products,
    partner: state.products.get('partner'),
}))(withFeatureToggling(CreditCardFeaturesInfo));
